// extracted by mini-css-extract-plugin
module.exports = {"matchPage":"style_matchPage__wYE_M","text_white":"style_text_white__YYuZL"};